<template>
  <div class="us-menu-wrap">
    <div class="menu-bg-wrap" :style="{aspectRatio: bannerRatio}">
      <img :src="bannerUrl" />
      <!-- 移动端logo -->
      <div class="sys-title-wrap" @click="onGo({key:'home'})">
        <img class="logo" src="/static/logo1.png" alt="">
      </div>
      <!-- 移动端理事名作入口 -->
      <div 
        v-if="currentMenuNameReal != 'council_composition'" 
        class="nav-menu" 
        @click="onGo({key:'council_composition'})"
      >{{ $t('menu.council_composition') }}</div>
      <!-- <div class="menu-bg-mask"></div> -->
    </div>
    <!-- <div class="banner-content">
    </div> -->
    <div class="menu-content-wrap">
      <!-- 菜单：PC端 -->
      <div class="menu-list">
        <div 
          v-for="(item,index) in getMenuList" 
          :key="index" 
          class="menu-item"
          :class="{active: currentMenuName == item.key}">
          <img class="menu-ele menu-ele1" src="@/assets/image/menu/sun.png" />
          <img class="menu-ele menu-ele2" src="@/assets/image/menu/cloud.png" />
          <img v-if="item.children" class="menu-more-arrow" src="@/assets/icons/arrow-t-light.png" />
          <div class="menu-item-inner" @click="onClickMenu(item)">{{ $t(`menu.${item.key}`) }}</div>
          <!-- 二级菜单 -->
          <div v-if="item.children" class="sub-menu" :class="{ show: activeMenu == item.key }">
            <div 
              v-for="(it,ii) in item.children" 
              :key="ii" 
              class="sub-menu-item"
              :class="{active: currentMenuNameReal == it.key}"
              @click.capture="onGo(it)">{{ $t(`menu.${it.key}`) }}</div>
          </div>
        </div>
      </div>
      <!-- 菜单：移动端 -->
      <div class="mini-menu-fold">
        <div class="mini-menu-btn" @click="showMiniMenu = true"></div>
        <ModeTitle v-if="currentMenuNameReal && (currentMenuNameReal != 'home') && (currentMenuNameReal != 'detail')" :title="$t(`menu.${currentMenuNameReal}`)" row />
        <div v-if="currentMenuNameReal == 'home'"  style="margin-top: 20px;" @click="onGo({key:'news'})">
          <ModeTitle 
            :title="$t(`menu.news`)" 
            num="1"/>
        </div>
        <!-- <div class="current-menu-name">{{ $t(`menu.${currentMenuName}`) }}</div> -->
        <div class="mini-menu-btn placeholder"></div>
      </div>
      <!-- 菜单：移动端下拉 -->
      <div class="mini-menu-wrap" :class="{show: showMiniMenu}">
        <div class="menu-bg">
          <div class="menu-bg-top"></div>
          <div class="menu-bg-m"></div>
          <div class="menu-bg-bottom"></div>
        </div>
        <div class="close-btn" @click="showMiniMenu = false">
          <img src="@/assets/icons/close.png">
        </div>
        <div class="menu-content">
          <div v-for="(item, index) in getMenuList" 
            :key="index" 
            class="menu-item-wrap">
            <div 
              class="menu-item"
              :class="{active: currentMenuName == item.key}"
              @click="onClickMenu(item)">
              <img class="menu-ele menu-ele1" src="@/assets/image/menu/sun.png" />
              <img class="menu-ele menu-ele2" src="@/assets/image/menu/cloud.png" />
              <div class="menu-item-inner">{{ $t(`menu.${item.key}`) }}</div>
              <!-- 二级菜单 -->
            </div>
            <div v-if="item.children" class="sub-menu-wrap" :class="{ show: activeMenu == item.key }">
              <div 
                v-for="(it,ii) in item.children" 
                :key="ii" 
                class="sub-menu-item"
                :class="{active: currentMenuName == it.key}">
                <div 
                  class="menu-item"
                  :class="{active: currentMenuNameReal == it.key}"
                  @click="onGo(it)">
                  <img class="menu-ele menu-ele1" src="@/assets/image/menu/sun.png" />
                  <img class="menu-ele menu-ele2" src="@/assets/image/menu/cloud.png" />
                  <div class="menu-item-inner">{{ $t(`menu.${it.key}`) }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ModeTitle from '@/components/mode-title.vue';
import { mapGetters, mapActions, mapMutations } from 'vuex'

export default {
  name: 'app-menu',
  components: { ModeTitle },
  data() {
    return {
      currentPath: "",
      activeMenu: '',
      bannerUrl: '/static/img/banner1.jpg',
      bannerRatio: '1439 / 851',
      showMiniMenu: false,
    }
  },
  computed: {
    ...mapGetters([
      'getMenuList',
      'getIndexInfo',
    ]),
    currentMenuName() {
      const currentPage = this.$route.name;
      for (const item of this.getMenuList) {
        if (item.key == currentPage) {
          return currentPage
        }
        if (item.children && item.children.find(it => it.key == currentPage)) {
          return item.key
        }
        if (currentPage == 'detail') {
          let art = window.localStorage.getItem('guangdong_culture_art');
          if (art) {
            const artData = JSON.parse(art);
            console.log(artData);
            switch (artData.tag) {
              case 'wenhuayaowen':
                return 'news'
                break;
              case 'zhongxindongtai':
                return 'moments'
                break;
              case 'wenhuajiaoliu':
                return 'exchange'
                break;
              case 'lishifengcai':
                return 'council_demeanour'
                break;
              default:
                break;
            }
          }
        }
      }
      return ''
    },
    currentMenuNameReal() {
      return this.$route.name;
    },
  },
  watch: {
    getIndexInfo(val) {
      if (val && val.banner && val.banner.wx && val.banner.wx[0]) {
        this.bannerUrl = val.banner.wx[0].img 
        var image = new Image();
        image.src = this.bannerUrl;
        image.onload = function() {
          this.bannerRatio = `${image.width} / ${image.height}`;
          console.log(`${image.width} / ${image.height}`);
        };
      }
    },
  },
  mounted() {
    
  },
  methods: {
    onClickMenu({ key, children }) {
      if (!children || children.length == 0) {
        this.onGo({key})
      } else {
        if (this.activeMenu == key) {
          this.activeMenu = null;
        } else {
          this.activeMenu = key;
        }
      }
    },
    onGo({key}) {
      this.activeMenu = '';
      this.showMiniMenu = false;
      if (this.$route.name != key) {
        this.$router.push(`/${key}`)
      }
    }
  }
}
</script>
<style lang="less" scoped>
.us-menu-wrap {
  width: 100%;
  // height: 500px;
  // padding-top: @navHeight;
  position: relative;
  .menu-bg-wrap {
    // position: absolute;
    position: relative;
    // left: 0;
    // top: 0;
    width: 100%;
    // height: 100%;
    aspect-ratio: 1920 / 834;
    position: relative;
    .menu-bg-mask {
      // display: none;
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 80px;
      background: linear-gradient(to top, @themeColor6 10%, rgba(@themeColor6, .1) 80%, transparent);
    }
    img {
      width: 100%;
      // height: 100%;
      // object-fit: cover;
    }
    .sys-title-wrap {
      display: none;
      position: absolute;
      width: 75%;
      position: absolute;
      top: 0;
      left: 50%;
      transform: translate(-50%, 0);
      img {
        width: 100%;
        height: auto;
      }
    }
    .nav-menu {
      display: none;
      position: absolute;
      right: 10px;
      bottom: 20px;
      background: rgba(#FBEEC4, .8);
      line-height: 26px;
      padding: 0 12px;
      border-radius: 4px;
      color: #605142;
      // font-weight: 600;
      z-index: 9;
      cursor: pointer;
      font-size: 14px;
    }
  }
  .menu-content-wrap {
    width: auto;
    max-width: @pageContentWidth;
    position: relative;
    margin: 10px auto 0;
    .menu-item {
      position: relative;
      width: 178px;
      // aspect-ratio: 160 / 74;
      aspect-ratio: 392 / 216;
      color: @themeColor3;
      background: url('@/assets/image/menu/menu-bg1.png');
      background-size: 100% 100%;
      cursor: pointer;
      user-select: none;
      opacity: 0.9;
      transition: all .5s;
      z-index: 999;
      .menu-item-inner {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 20px;
      }
      .menu-ele {
        position: absolute;
        transition: all .5s;
        opacity: 0;
      }
      .menu-ele1 {
        left: 0px;
        top: 0px;
        width: 40px;
        aspect-ratio: 1 / 1;
      }
      .menu-ele2 {
        right: 10px;
        bottom: 0px;
        width: 72px;
        aspect-ratio: 88 / 38;
      }
      .menu-more-arrow {
        position: absolute;
        right: calc(50% - 8px);
        bottom: 16px;
        width: 16px;
        aspect-ratio: 1 / 1;
      }
      &.active {
        opacity: 1;
        color: #FFE3A5;
        font-weight: 600;
        .menu-ele {
          opacity: 1;
        }
        .menu-ele1 {
          left: -10px;
          top: -14px;
        }
        .menu-ele2 {
          right: -14px;
        }
      }
    }
    .menu-list {
      // position: absolute;
      // left: 0px;
      // bottom: 60px;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 24px;
      .menu-item {
        // 子菜单
        &.active {
          .menu-ele2 {
            right: 0px;
          }
        }
        .sub-menu {
          position: absolute;
          top: 100%;
          left: 5%;
          width: 90%;
          padding: 8px 16px;
          background: #605142;
          border: 2px solid #E2C186;
          box-shadow: 0 0 40px rgba(#000000, .2);
          border-radius: 24px;
          opacity: 0;
          transition: all .3s;
          z-index: 999;
          &.show {
            opacity: 1;
          }
          .sub-menu-item {
            text-align: center;
            line-height: 2;
            font-size: 20px;
            color: #E2C186;
            font-weight: 400;
            &.active {
              color: #FFE3A5;
            }
            &:hover {
              color: #FFE3A5;
            }
          }
        }
      }
    }
    .mini-menu-fold {
      display: none;
      // position: absolute;
      // bottom: 0;
      width: 100%;
      align-items: center;
      justify-content: space-between;
      height: 52px;
      z-index: 999;
      // margin-top: 10px;
      .current-menu-name {
        font-family: SanJiXingKaiCu;
        font-size: 24px;
        color: @themeColor2;
      }
      .mini-menu-btn {
        height: 52px;
        aspect-ratio: 1 / 1;
        background: url('@/assets/image/menu/m-menu-btn.png');
        background-size: 100% 100%;
        &.placeholder {
          background: transparent;
        }
      }
    }
    .mini-menu-wrap {
      // width: 90%;
      width: 90vw;
      left: 5vw;
      display: none;
      position: fixed;
      top: -100vh;
      z-index: 999;
      transition: all .5s;
      .close-btn {
        position: absolute;
        bottom: -48px;
        left: calc(50% - 20px);
        content: "";
        width: 40px;
        height: 40px;
        background-color: rgba(#000000, .7);
        border-radius: 50%;
        img {
          width: 36px;
          height: 36px;
          margin: 2px;
        }
      }
      .menu-content {
        position: relative;
        max-height: 85vh;
        overflow-y: auto;
        padding: 24px 48px;
        .menu-item-wrap {
          width: 100%;
          display: flex;
          flex-direction: column;
          .menu-item {
            width: 140px; 
            aspect-ratio: 160 / 60;
          }
          &:nth-child(even) {
            // align-items: flex-end;
          }
          &:nth-child(odd) {
            align-items: flex-start;
          }
          .sub-menu-wrap {
            // display: flex;
            // height: 0;
            height: auto;
            overflow: hidden;
            &.show {
              height: auto;
            }
            .sub-menu-item {
              padding-left: 16px;
              .menu-item {
                width: 120px;
                .menu-item-inner {
                  font-size: 16px;
                }
                .menu-ele1 {
                  width: 32px;
                }
                .menu-ele2 {
                  width: 48px;
                  // aspect-ratio: 88 / 38;
                }
              }
            }
          }
        }
      }
      .menu-bg {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        position: absolute;
        top: 0;
        .menu-bg-top {
          width: 100%;
          aspect-ratio: 34 / 21;
          background: url('@/assets/image/menu/mini-menu-wrap-top.png');
          background-size: 100% 100%;
          flex-shrink: 0;
          flex-grow: 0;
        }
        .menu-bg-m {
          width: 100%;
          flex: 1;
          background: url('@/assets/image/menu/mini-menu-wrap-m.png');
          background-size: 100% auto;
          background-repeat: repeat-y;
          transform: scaleY(1.05);
        }
        .menu-bg-bottom {
          width: 100%;
          aspect-ratio: 34 / 23;
          background: url('@/assets/image/menu/mini-menu-wrap-bottom.png');
          background-size: 100% 100%;
          flex-shrink: 0;
          flex-grow: 0;
        }
      }
    }
  }
}
@media screen and (min-width: @mdW) {
  .us-menu-wrap {
    .menu-bg-wrap {
      max-height: 84vh;
      overflow: hidden;
    }
  }
}
@media screen and (max-width: @mdW) {
.us-menu-wrap {
  .menu-bg-wrap {
    // height: 770px;
    overflow: hidden;
    .sys-title-wrap {
      display: block;
    }
    .nav-menu {
      display: block;
    }
  }
}
}
@media screen and (max-width: @xsW) {
.us-menu-wrap {
  // padding: 16px 16px 0 16px;
  padding-top: @navMHeight;
  // height: 300px;
  .menu-bg-wrap {
    .menu-bg-mask {
      display: block;
      width: 100%;
      // height: 140px;
      aspect-ratio: 25 / 3;
      height: auto;
      background: url('@/assets/image/menu/moji-bg.png');
      background-size: 100% 100%;
    }
    .sys-title-wrap {
      display: block;
    }
    .nav-menu {
      display: block;
    }
  }
  .menu-item-inner {
    font-size: 14px !important;
  }
  .menu-content-wrap {
    .menu-list {
      display: none;
    }
    .mini-menu-fold {
      display: flex;
    }
    .mini-menu-wrap {
      display: block;
      &.show {
        top: 80px;
      }
    }
  }
}

}
</style>
